import { render } from "./rate.view.vue?vue&type=template&id=71c6c212&scoped=true&ts=true"
import script from "./rate.view.vue?vue&type=script&lang=ts"
export * from "./rate.view.vue?vue&type=script&lang=ts"

import "./rate.view.vue?vue&type=style&index=0&id=71c6c212&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c6c212"]])

export default __exports__